'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Provides pluggable UI for the operation summary.  This component includes the
 * AuthorizeOperationBtn, but it can be overridden to include additional UI
 * elements.
 */
var OperationActions = function (_PureComponent) {
	_inherits(OperationActions, _PureComponent);

	function OperationActions() {
		_classCallCheck(this, OperationActions);

		return _possibleConstructorReturn(this, (OperationActions.__proto__ || Object.getPrototypeOf(OperationActions)).apply(this, arguments));
	}

	_createClass(OperationActions, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    authActions = _props.authActions,
			    authSelectors = _props.authSelectors,
			    getComponent = _props.getComponent,
			    operationProps = _props.operationProps;

			var _operationProps$toJS = operationProps.toJS(),
			    isAuthorized = _operationProps$toJS.isAuthorized;

			var security = operationProps.get('security');
			var AuthorizeOperationBtn = getComponent('authorizeOperationBtn');

			return _react2.default.createElement(AuthorizeOperationBtn, {
				key: 'operation-action-auth',
				isAuthorized: isAuthorized,
				onClick: function onClick() {
					var applicableDefinitions = authSelectors.definitionsForRequirements(security);
					authActions.showDefinitions(applicableDefinitions);
				}
			});
		}
	}]);

	return OperationActions;
}(_react.PureComponent);

var _default = OperationActions;
exports.default = _default;


OperationActions.propTypes = {
	/**
  * The auth actions component.
  */
	authActions: _propTypes2.default.object.isRequired,
	/**
  * The swagger-ui auth selectors.
  */
	authSelectors: _propTypes2.default.object.isRequired,
	/**
  * The swagger-ui getComponent function.
  */
	getComponent: _propTypes2.default.func.isRequired,
	/**
  * The swagger-ui operation propertties
  */
	operationProps: _propTypes2.default.object.isRequired
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(OperationActions, 'OperationActions', 'src/components/OpenAPI/OperationActions.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/OpenAPI/OperationActions.jsx');
}();

;